const homeStyles = {
  header: {
    color: "#2e2e2e",
    fontSize: "50px",
    marginBottom: "25px",
  },
} as const;

export default homeStyles;
